import { OrgUnitType } from './OrgUnitType';

export type envType = 'dev' | 'stage' | 'prod' | 'localDev' | 'localStage';

export const mgPrisFeatures = [
  'help-center',
  'supplier-price-change-notification-config',
  'sales-price-condition',
  'local_campaigns',
  'chatbot',
  'price-rounding',
  'price-control',
  'all-conditions',
  'local-price-suggestions',
  'new-dashboard',
  'discount-matrix',
  'replace-item',
] as const;

export type MgPrisFeature = (typeof mgPrisFeatures)[number];

export interface FeatureScope {
  orgUnitType?: OrgUnitType;
  country?: 'NO' | 'SE';
}

export interface FeatureFlag {
  name: MgPrisFeature;
  enabled: boolean;
  useMockApi?: boolean;
  excludedScopes?: FeatureScope[];
}

export interface BaseConfig {
  env: envType;
  version: string;
  buildTime?: number;
  appInfo: {
    name: string;
    key: string;
  };
  muiLicenseKey: string;
  sentryDsn?: string;
  country: 'NO' | 'SE';
  retailerLogoBaseUrl: string;
}

export interface SanityConfig {
  apiVersion: string;
  projectId: string;
  dataset: string;
  useCdn?: boolean;
}

export interface MgPrisConfig extends BaseConfig {
  mpe: {
    url: string;
  };
  auth0: {
    clientId: string;
    domain: string;
    audience: string;
    mpeAudience: string;
    mgAppsBffAudience: string;
  };
  mgAppsBff: {
    url: string;
  };
  featureFlags: FeatureFlag[];
  gaMeasurementId?: string;
  sanity: SanityConfig;
  hotjar?: {
    id: number;
    version: number;
  };
  clarity?: {
    id: string;
  };
}
